/* Order of types is important and shouldn't be changed as 'createRecordId' relies on it!
   'remote_broadcast' has to be before 'remote_content'.
   Remote broadcast events contain both remote_broadcast_id and remote_content_id
*/
const types = ['remote_broadcast', 'remote_content', 'broadcast', 'content'];

const typeFromRecord = record => types.find(type => record[`${type}_id`]);

const isLegacyConradEvent = conradEvent =>
  conradEvent && (!conradEvent.data || !conradEvent.metadata);

/**
 * Extract CONRAD event data object, which results into legacy conrad event format
 */
const extractConradEventData = (conradEvent) => {
  if (isLegacyConradEvent(conradEvent)) {
    return conradEvent;
  }
  if (!conradEvent) return null;
  const { metadata, data } = conradEvent;
  const { sent_at, received_at } = metadata.trace ? metadata.trace[0] : {};
  return {
    ...data,
    fired_at: sent_at || received_at,
  };
};

const createRecordId = (conradEvent) => {
  const data = extractConradEventData(conradEvent);
  const recordType = types.find(type => data[`${type}_id`]);
  const id = data[`${recordType}_id`];
  const segments = [recordType, id];

  if (recordType === 'remote_broadcast') {
    const { source, remote_content_id } = data;
    segments.splice(1, 0, source, remote_content_id);
  }
  if (recordType === 'remote_content') {
    const { source } = data;
    segments.splice(1, 0, source);
  }

  return segments.join('::');
};

const typeFromRecordId = (recordId) => {
  const [type] = recordId.split('::');
  return type;
};

const createFromRecordId = (recordId, { withType = true } = {}) => {
  const segments = recordId.split('::');
  const item = {};

  const type = segments.shift();
  if (withType) item.type = type;

  if (['broadcast', 'content'].includes(type)) return { [`${type}_id`]: segments.shift(), ...item };

  item.source = segments.shift();
  item.remote_content_id = segments.shift();
  if (type === 'remote_broadcast') item.remote_broadcast_id = segments.shift();
  return item;
};

/**
 * Creates legacy record ID (with only one `:`), used by legacy ConradStations/AddConradEVents
 */
const createRecordIdLegacy = (conradEvent) => {
  const data = extractConradEventData(conradEvent);
  const prefix = data.broadcast_id ? 'broadcast' : 'content';
  const id = data.broadcast_id || data.content_id;
  return `${prefix}:${id}`;
};

const decodeRecordIdLegacy = (recordId) => {
  const match = /(broadcast|content):([\w]+)/.exec(recordId);
  if (!match || typeof match[2] === 'undefined') return {};
  const [, type, id] = match;
  return { type, id };
};

const normalizeRecordId = recordId =>
  recordId && recordId.replace(/^([\w]+)(:{1})([\w]+)$/, '$1::$3');

const legacyRecordId = recordId =>
  recordId && recordId.replace(/^([\w]+)(:{2})([\w]+)$/, '$1:$3');

module.exports = {
  isLegacyConradEvent,
  extractConradEventData,
  createRecordId,
  typeFromRecordId,
  typeFromRecord,
  createFromRecordId,
  createRecordIdLegacy,
  decodeRecordIdLegacy,
  normalizeRecordId,
  legacyRecordId,
};
